var $9d104b1e79ae2a44$exports = {};
$9d104b1e79ae2a44$exports = {
    "collapse": `\xd6sszecsuk\xe1s`,
    "expand": `Kibont\xe1s`
};


export {$9d104b1e79ae2a44$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
